<template lang="pug">
  .d-inline-block
    v-dialog(v-model="showPlans" width='680px')
      v-card(data-cy="plans-storm-dialer-modal")
        title-bar(dark) {{title}}
          template(slot="extras")
            v-btn.close-icon(icon @click="hide")
              v-icon close
        v-card-text
          v-layout.top(v-if="isNotBundled" row wrap)
            v-flex(xs5)
            v-flex(xs7)
              v-layout(wrap)
                v-flex(xs6)
                v-flex(xs6)
                  v-layout(row)
                    v-flex(xs12)
                      v-flex.xs11.offset-xs1
                        div.popular-tab Best choice

          v-layout(row wrap)
            v-flex(xs5)
            v-flex(xs7)
              v-layout(row wrap)
                v-flex(v-if="isNotBundled" xs6)
                  v-layout(wrap)
                    v-flex.xs11.offset-xs1.border-plan.clear-border-bottom
                      h3.center.title-plan Single Line
                      v-layout(row wrap)
                        v-flex(xs12)
                          h4(:class="{ 'visibility-hidden' : (hasAddonDialerSingle || hasCRMPremierPlan) }").center $99/mo
                      v-layout(row wrap justify-center)
                        v-btn.btn-subscribe.current-plan(v-if="hasAddonDialerSingle" small :disabled="true" ) Current Plan
                        v-btn.primary.btn-subscribe(
                          v-if="!hasPlanStormDialer"
                          flat
                          small
                          @click="subscribe(addonSingleLinePerUnit)"
                        ) Subscribe Now
                        div.btn-space(v-if="hasAddonDialerMulti")
                v-flex(xs6)
                  v-layout(row wrap)
                    v-flex(xs12)
                      v-layout(wrap)
                        v-flex.xs11.offset-xs1.border-plan.clear-border-bottom
                          h3.center.title-plan Multi Line
                          v-layout(row wrap)
                            v-flex(xs12)
                              h4(:class="{ 'visibility-hidden' : hasAddonDialerMulti }").center {{pricingMultiDialer}}
                          v-layout(row wrap justify-center)
                            v-btn.btn-subscribe.current-plan(v-if="hasAddonDialerMulti" small :disabled="true") Current Plan
                            v-btn.primary.btn-subscribe(v-else flat small @click="subscribe(addonMultiLinePerUnit)") Subscribe Now
          v-layout(row wrap)
            v-flex.list-features(xs5)
              v-layout.item.item-feature(row wrap) Unlimited Minutes
                v-tooltip(bottom)
                  template(slot="activator")
                    v-icon(small) info
                  span Make calling a regular part of each day to help reach sales goals!
              v-layout.item.item-feature(row wrap) Call Recording
                v-tooltip(bottom)
                  template(slot="activator")
                    v-icon(small) info
                  span Keep recordings of any or all conversations. Have the option to record continuously or just when you want.
              v-layout.item.item-feature(row wrap) Mutiple Caller ID
                v-tooltip(bottom)
                  template(slot="activator")
                    v-icon(small) info
                  span Choose what number shows as your caller ID. Use any number (cell, office, google voice) that you own!
              v-layout.item.item-feature(row wrap) VoiceMail Drop
                v-tooltip(bottom)
                  template(slot="activator")
                    v-icon(small) info
                  span Record Voicemail messages that you would like to easily share with your contacts
              v-layout.item.item-feature(row wrap) TimeZones Call Protection
                v-tooltip(bottom)
                  template(slot="activator")
                    v-icon(small) info
                  span  Automatically prevent making calls too early or too late based on the area code of the phone number.
              v-layout.item.item-feature(row wrap) Callback Message
                v-tooltip(bottom)
                  template(slot="activator")
                    v-icon(small) info
                  span Record a message that is played if you get two or more live answers on the Multi Line Dialer.
              v-layout.item.item-feature(row wrap) Call up to 3 lines simultaneously
                v-tooltip(bottom)
                  template(slot="activator")
                    v-icon(small) info
                  span Increase efficiency and make more connections with the Multi Line dialer.

            v-flex(xs7)
              v-layout(wrap)
                v-flex(v-if="isNotBundled" xs6)
                  v-layout(wrap)
                    v-flex.xs11.offset-xs1.border-plan.clear-border-top
                      v-layout.item(row wrap justify-center v-if="!hasPlanStormDialer")
                        v-icon.check-icon check_circle_outline
                      v-layout.item(row wrap justify-center)
                        v-icon.check-icon check_circle_outline
                      v-layout.item(row wrap justify-center)
                        v-icon.check-icon check_circle_outline
                      v-layout.item(row wrap justify-center)
                        v-icon.check-icon check_circle_outline
                      v-layout.item(row wrap justify-center)
                        v-icon.check-icon check_circle_outline
                      v-layout.item(row wrap justify-center)
                        v-icon.check-icon &nbsp;
                      v-layout.item(row wrap justify-center)
                        v-icon &nbsp;
                      v-layout.item(row wrap justify-center)
                        v-icon &nbsp;
                      v-layout.item(row wrap justify-center v-if="hasAddonDialerMulti")
                        a(@click="confirmDowngrade(addonSingleLinePerUnit)") Downgrade to Single Line
                      v-layout.item(v-if="!hasCRMPremierPlan && hasAddonDialerSingle && isCancellable" row wrap justify-center)
                        a(@click="confirmCancel('single-line')") Cancel Subscription
                v-flex(xs6)
                  v-flex(xs12)
                    v-layout(wrap)
                      v-flex.xs11.offset-xs1.border-plan.clear-border-top
                        v-layout.item(row wrap justify-center v-if="!hasPlanStormDialer")
                          v-icon.check-icon check_circle_outline
                        v-layout.item(row wrap justify-center)
                          v-icon.check-icon check_circle_outline
                        v-layout.item(row wrap justify-center)
                          v-icon.check-icon check_circle_outline
                        v-layout.item(row wrap justify-center)
                          v-icon.check-icon check_circle_outline
                        v-layout.item(row wrap justify-center)
                          v-icon.check-icon check_circle_outline
                        v-layout.item(row wrap justify-center)
                          v-icon.check-icon check_circle_outline
                        v-layout.item(row wrap justify-center)
                          v-icon.check-icon check_circle_outline
                        v-layout.item(row wrap justify-center)
                          v-icon.check-icon check_circle_outline
                        v-layout.item(v-if="showMultiLineCancelSubsOption" row wrap justify-center)
                          a(@click="confirmCancel('multi-line')") Cancel Subscription
                        v-layout.item.last-item(v-if="showLastRowInMultiLine" row wrap justify-center)
                          v-icon &nbsp;
    liondesk-dialog(
      dialog-title="Are you sure you want to cancel?"
      :value="cancelSubscription"
      :hide-cancel-button="false"
      :dialog-body-html="true"
      width="600px"
      ok-button-text="Cancel Subscription"
      cancel-button-text="Keep Plan"
      @click:ok="confirmCancelAddon"
      @click:cancel="cancelSubscription = false"
    )
      template(slot="body")
        div
          p.mt-2.mb-5 Your last day to access the LionDesk Power Dialer will be <strong> {{dateEnd | formatDate}} </strong>. Are you sure you want to cancel your {{ getPlanSelected(subscriptionSelected) }} Plan?
    liondesk-dialog(
      dialog-title="Are you sure you want to downgrade?"
      :value="downgradeSubscription"
      :hide-cancel-button="false"
      :dialog-body-html="true"
      width="600px"
      ok-button-text="Downgrade Plan"
      cancel-button-text="Keep Plan"
      @click:ok="downgrade"
      @click:cancel="downgradeSubscription = false"
    )
      template(slot="body")
        div
          p.mt-2.mb-5  Your last day to access the Multi Line Dialer will be <strong>{{dateEnd | formatDate}} </strong>. Are you sure you want to downgrade to Single Line?
    liondesk-dialog(
      dialog-title="Confirm Action"
      :value="paymentUserSubscribed"
      :hide-cancel-button="false"
      :dialog-body-html="true"
      :loading="loadingRequest"
      width="600px"
      ok-button-text="Add Plan"
      cancel-button-text="Return"
      @click:ok="subscribePlan"
      @click:cancel="closeConfirmAction"
    )
      template(slot="body")
        div
          p.mt-2.mb-5 Are you sure you want to start your LionDesk Power Dialer {{ getPlanSelected(subscriptionSelected) }} Plan?
    liondesk-dialog(
      dialog-title="Payment Status"
      :value="showPaymentResult"
      :hide-cancel-button="true"
      :dialog-body-html="true"
      width="600px"
      ok-button-text="Ok"      
      @click:ok="setShowPaymentResult(false)"
    )
      template(slot="body")
        div(v-if="errorPaymentResult != null")
          p {{errorPaymentResult}}
        div(v-else)
          p {{messageSuccessSubcribe}}
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import TitleBar from '@/Core/components/TitleBar';
import LiondeskDialog from '@/Core/components/LiondeskDialog';
import { formatDate } from '@/Core/filters/dates';
import {
  ADDON_STORM_DIALER_MULTI,
  ADDON_STORM_DIALER_SINGLE,
  ADDON_STORM_DIALER_MULTI_PER_UNIT,
  ADDON_STORM_DIALER_SINGLE_PER_UNIT,
  ADDON_STORM_DIALER_SINGLE_MONTHLY_BUNDLE,
  ADDON_STORM_DIALER_SINGLE_ANNUAL_BUNDLE,
  MULTI_DIALER_CHARGEBEE_ID,
  MULTI_DIALER_PER_UNIT_CHARGEBEE_ID,
  MULTI_DIALER_CRM_PREMIER_CHARGEBEE_ID,
  SINGLE_DIALER_CHARGEBEE_ID,
  SINGLE_DIALER_PER_UNIT_CHARGEBEE_ID,
  MULTI_DIALER_MONTHLY_BUNDLE_CHARGEBEE_ID,
  SINGLE_DIALER_MONTHLY_BUNDLE_CHARGEBEE_ID,
  MULTI_DIALER_ANNUAL_BUNDLE_CHARGEBEE_ID,
  SINGLE_DIALER_ANNUAL_BUNDLE_CHARGEBEE_ID,
  SINGLE_DIALER_MONTHLY_PROMOTE_AGENT_CHARGEBEE_ID,
  MULTI_DIALER_MONTHLY_PROMOTE_AGENT_CHARGEBEE_ID,
  ADDON_PLANS,
  VALID_ADDON_STATUS_LIST,
  hasExpiredCC,
  isLionDeskStaff,
  isPremierMonthlyPlan,
  isPremierAnnualPlan,
} from '@/Core/config/addons';
import { PLAN_LD_V2_ELITE_BUNDLE, BUNDLE_SKUS } from '@/Core/config/subscription'

export default {
  name: 'PlansStormDialer',
  filters: {
    formatDate,
  },
  components: {
    TitleBar,
    LiondeskDialog,
  },
  props: {
    dialog: false,
    hideDialerDialog: {
      type: Function,
      default: () => {},
    },
  },
  async created() {
    this.getUserAddons();
  },
  methods: {
    ...mapMutations('payment', ['setShowAddPayment','setShowPlans', 'setAddon', 'setShowPaymentResult', 'setShowDetailPlanSelected']),
    ...mapMutations('contactsTable', ['setSuccessfulDelete', 'setSuccessMessage', 'setContactTableError']),
    ...mapActions('payment', ['cancelAddon', 'updateAddon', 'addAddon', 'resetErrorMessage', 'getUserAddons', 'toggleBillingLength']),
    ...mapActions('userInformation', ['getSubscription']),
    ...mapActions('contactsTable', ['clearContactTableMessage']),
    async subscribePlan(){
      if (this.loadingRequest) return;
      this.loadingRequest = true;
      if(!this.subscriptionSelected) return;
      if(this.hasPlanStormDialer){
        const singleLine = this.singleLineType();
        const multiLine= this.isStormDialerPerUnit() ? this.addonMultiLinePerUnit : this.addonMultiLine;

        const addonCurrent = this.hasAddonDialerSingle ? singleLine : multiLine;
        await this.updateAddon({
          addonIdSelected: this.subscriptionSelected,
          previousAddonId: addonCurrent,
        });
        this.getUserAddons();
      } else {
        await this.addAddon(this.subscriptionSelected);
      }
      this.loadingRequest = false;
      this.closeConfirmAction()
    },
    subscribe(addonId){
      this.subscriptionSelected = addonId;
      this.setShowPlans(false);
      this.setAddon(this.subscriptionSelected);

      if (this.isUserWithoutCC) {
        this.setShowDetailPlanSelected(true);
        this.toggleBillingLength(true);
      } else {
        this.paymentUserSubscribed = true;
      }
    },
    hide(){
      this.loadingRequest = false;
      this.resetErrorMessage();
      this.clearContactTableMessage();
      this.setShowPlans(false);
      this.hideDialerDialog();
    },
    confirmCancel(addonId){
      let addonType;
      if (addonId === 'single-line') {
        addonType = this.singleLineType();
      } else {
        addonType = this.isStormDialerPerUnit() ? this.addonMultiLinePerUnit : this.addonMultiLine;
      }
      this.subscriptionSelected = addonType;
      this.cancelSubscription = true;
    },
    confirmCancelAddon(){
      this.cancelAddon(this.subscriptionSelected);
      this.cancelSubscription = false;
    },
    downgrade(){
      const previousAddon = this.isStormDialerPerUnit() ? this.addonMultiLinePerUnit : this.addonMultiLine;
      let addonSelected = this.singleLineType();

      this.updateAddon({addonIdSelected: addonSelected, previousAddonId: previousAddon});
      this.downgradeSubscription = false;
    },
    confirmDowngrade(addonId){
      this.subscriptionSelected = addonId;
      this.downgradeSubscription = true;
    },
    singleLineType() {
      let addonSelected;
      if (isPremierMonthlyPlan(this.user)) {
        addonSelected = this.addonSingleLineMonthlyBundle;
      } else if (isPremierAnnualPlan(this.user)) {
        addonSelected = this.addonSingleLineAnnualBundle;
      } else {
        addonSelected = this.isStormDialerPerUnit() ? this.addonSingleLinePerUnit : this.addonSingleLine;
      }
      return addonSelected;
    },
    showMessageSuccess(message){
      this.setSuccessMessage(message);
      this.setSuccessfulDelete(true);
    },
    showMessageError(message){
      this.setContactTableError(message);
    },
    closeConfirmAction(){
      this.paymentUserSubscribed = false;
      this.setShowPlans(true);
    },
    getPlanSelected(plan){
      if(!plan) return '';
      return this.plans.find(({ id }) => id === plan).planName;
    },
    isStormDialerPerUnit() {
      if (this.userAddons) {
        return this.userAddons.find(({ id_item, txt_status }) => (
          [SINGLE_DIALER_PER_UNIT_CHARGEBEE_ID,
            MULTI_DIALER_PER_UNIT_CHARGEBEE_ID,
            MULTI_DIALER_CRM_PREMIER_CHARGEBEE_ID].includes(id_item) && VALID_ADDON_STATUS_LIST.includes(txt_status)
        ));
      }
      return false;
    },
  },
  computed: {
    ...mapState('payment', ['error', 'showPaymentResult', 'errorPaymentResult', 'createAddonResponse', 'cancelAddonResponse', 'updateAddonResponse', 'showPlans']),
    ...mapState('userInformation', ['user', 'subscription']),
    ...mapState('contactsTable', ['successMessage']),
    ...mapGetters('payment', ['planName', 'userAddons', 'hasPlanStormDialer',]),
    ...mapGetters('userInformation', ['hasTrial', 'isOnBrokerPurchasedPlan', 'hasUserMLS', 'userHasFeatureFlag']),
    title() {
      return this.hasPlanStormDialer ? 'Manage Subscriptions': 'Select Power Dialer';
    },
    dateEndTrial(){
      let date = new Date();
      return date.setDate(date.getDate() + 7);
    },
    hasAddonDialerSingle() {
      if (this.userAddons) {
        return this.userAddons.find(({ id_item, txt_status }) => (
          [SINGLE_DIALER_CHARGEBEE_ID,
            SINGLE_DIALER_PER_UNIT_CHARGEBEE_ID,
            SINGLE_DIALER_MONTHLY_BUNDLE_CHARGEBEE_ID,
            SINGLE_DIALER_ANNUAL_BUNDLE_CHARGEBEE_ID,
            SINGLE_DIALER_MONTHLY_PROMOTE_AGENT_CHARGEBEE_ID].includes(id_item) && VALID_ADDON_STATUS_LIST.includes(txt_status)
        ));
      }
      return false;
    },
    hasAddonDialerMulti() {
      if (this.userAddons) {
        return this.userAddons.find(({ id_item, txt_status }) => (
          [MULTI_DIALER_CHARGEBEE_ID,
            MULTI_DIALER_PER_UNIT_CHARGEBEE_ID,
            MULTI_DIALER_MONTHLY_BUNDLE_CHARGEBEE_ID,
            MULTI_DIALER_ANNUAL_BUNDLE_CHARGEBEE_ID,
            MULTI_DIALER_CRM_PREMIER_CHARGEBEE_ID,
            MULTI_DIALER_MONTHLY_PROMOTE_AGENT_CHARGEBEE_ID].includes(id_item) && VALID_ADDON_STATUS_LIST.includes(txt_status)
        ));
      }
      return false;
    },
    isUserWithoutCC(){
      if (isLionDeskStaff(this.user)) {
        return false;
      }
      if (this.hasAddonDialerSingle || this.hasAddonDialerMulti) return false;
      if (hasExpiredCC(this.user)) {
        return true;
      }
      return (this.hasTrial || this.isOnBrokerPurchasedPlan || this.hasUserMLS);
    },
    dateEnd(){
      if(this.subscription){
        const dateStarted = parseInt(this.subscription.next_billing_at);
        const date = new Date(dateStarted * 1000);
        return date;
      }
    },
    isNotBundled() {
      return this.user.subscriptionOverview.details.id_item != PLAN_LD_V2_ELITE_BUNDLE
    },
    hasCRMPremierPlan() {
      return (isPremierMonthlyPlan(this.user) || isPremierAnnualPlan(this.user));
    },
    isCancellable() {
      return !BUNDLE_SKUS.includes(this.user.subscriptionOverview.details.id_item);
    },
    pricingMultiDialer() {
      if(isPremierMonthlyPlan(this.user) || isPremierAnnualPlan(this.user)){
        return '$50/mo';
      }
      return '$149/mo'
    },
    showMultiLineCancelSubsOption() {
      return (!this.hasCRMPremierPlan && this.hasAddonDialerMulti && this.isCancellable);
    },
    showLastRowInMultiLine() {
      return (
        (!this.hasCRMPremierPlan && this.hasAddonDialerSingle && this.isCancellable) ||
        (this.hasCRMPremierPlan && this.hasAddonDialerMulti)
      );
    },
  },
  watch: {
    dialog: {
      handler(value) {
        this.setShowPlans(value);
      },
    },
    error: {
      handler(value) {
        if (value) {
          this.paymentUserSubscribed = false;
          this.showMessageError(this.messageError);
        }
      }
    },
    createAddonResponse: {
      handler(value){
        if (value) {
          this.paymentUserSubscribed = false;
          this.showMessageSuccess(this.messageSuccessSubcribe);
        }
      }
    },
    cancelAddonResponse: {
      handler(value){
        if (value) {
          this.showMessageSuccess(this.messageSuccessCancel);
        }
      }
    },
    updateAddonResponse: {
      handler(value){
        if (value) {
          this.showMessageSuccess(this.messageSuccessUpdate);
        }
      }
    },
    userAddons: {
      immediate: true,
      deep: true,
      handler(value){
        if(!value || !this.hasPlanStormDialer) return;
        this.getSubscription(this.hasPlanStormDialer.id_chargebee);
      }
    },
  },
  data() {
    return {
      addonSingleLine: ADDON_STORM_DIALER_SINGLE,
      addonMultiLine: ADDON_STORM_DIALER_MULTI,
      addonSingleLinePerUnit: ADDON_STORM_DIALER_SINGLE_PER_UNIT,
      addonMultiLinePerUnit: ADDON_STORM_DIALER_MULTI_PER_UNIT,
      addonSingleLineMonthlyBundle: ADDON_STORM_DIALER_SINGLE_MONTHLY_BUNDLE,
      addonSingleLineAnnualBundle: ADDON_STORM_DIALER_SINGLE_ANNUAL_BUNDLE,
      plans: ADDON_PLANS,
      cancelSubscription: false,
      subscriptionSelected: null,
      downgradeSubscription: false,
      paymentUserSubscribed: false,
      loadingRequest: false,
      messageSuccessUpdate: 'The plan has been updated successfully',
      messageSuccessCancel: 'The plan has been cancelled successfully',
      messageSuccessSubcribe: 'LionDesk Power Dialer plan has been added successfully',
      messageError: 'An error occurred while making the request',
    };
  },
};
</script>
<style lang="scss" scoped>
@import "@/Core/assets/scss/main.scss";
.popular-tab {
  background-color: var(--v-primary-base);
  color: white;
  border-radius: 5px 5px 0px 0px;
  text-align: center;
  margin-bottom: -27px;
  letter-spacing: -0.05em;
  font-weight: 700;
  font-size: 15px;
  padding: 2px 0 2px 0;
}

.time-offer {
  background-color: $lion-dark-blue;
  color: white;
  border-radius: 2px 2px 2px 2px;
  text-align: center;
  font-weight: 900;
  padding: 4px 0 4px 0;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  border-radius: 4px;
}

.item{
  margin-bottom: 12px;
  margin-top: 12px;
}

.item-feature{
  height: 24px;
}

.clear-border-top{
  border-top: 0px !important;
}

.clear-border-bottom{
  border-bottom: 0px !important;
}

.top {
  height: 25px;
}

.center {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.border-plan {
  border: 1px solid var(--v-primary-base);
}


.btn-subscribe{
  text-transform: none;
  font-size: 14px;
  font-weight: inherit;
}

.check-icon {
  color: var(--v-primary-base);
}

.close-icon {
  color: white;
}

.title-plan {
  margin-top: 10px;
  font-size: 18px;
}

.current-plan{
  font-weight: bolder;
}

.btn-space{
  height: 40px;
}

.list-features {
  font-size: 14px;
}

.text-help-trial {
  text-align: justify;
  margin-top: -10px;
  font-size: 13px;
}

.visibility-hidden {
  visibility: hidden;
}

.last-item {
  margin-bottom: 9px !important;
}

button {  
  .v-btn__content {
    padding-left: 4px;
    padding-right: 4px;
  }
}

</style>
